import { useMutation, useQuery } from "react-query";
import { IndirectEmissions } from "../../../api";
import { useAuth } from "../../../context";

export const indirectEmissionsKeys = {
  items: () => ["indirectEmissionsItems"]
};

export function useGetIndirectEmissionsItems(params, config) {
  const { callApi } = useAuth();
  return useQuery([...indirectEmissionsKeys.items(), params.queryParams.page],
    () => callApi(IndirectEmissions.getIndirectEmissionsItems, params), config);
}

export function useAddIndirectEmissionsItem(config) {
  const { callApi } = useAuth();
  return useMutation(({questionnaireId, data, type}) =>
    callApi(IndirectEmissions.addIndirectEmissionsItem, { questionnaireId, data, type }), config);
}

export function useUpdateIndirectEmissionsItem(config) {
  const { callApi } = useAuth();
  return useMutation(({questionnaireId, recordId, data, type}) =>
    callApi(IndirectEmissions.updateIndirectEmissionsItem, { questionnaireId, recordId, data, type }), config);
}

export function useDeleteIndirectEmissionsItem(config) {
  const { callApi } = useAuth();
  return useMutation(({questionnaireId, recordId, type}) =>
    callApi(IndirectEmissions.deleteIndirectEmissionsItem, { questionnaireId, recordId, type }), config);
}